import { colors, fonts } from '@grupoboticario/flora-tokens/dist/blzPro/web/ds'

export const blzPro = {
  colors,
  fonts,
}
